// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1il95","col":"styles_col__3SHG5"};